import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FieldsetModule } from 'primeng/fieldset'
import { DiagnosisSelectorComponent, FacilityLocationSearchComponent, IMedicalBillLine, MedicalBillLine, ModifierSelectorComponent, PartySearchComponent, ProcedureSelectorComponent } from '@harlowe/core';
import { DropdownModule } from 'primeng/dropdown';
import { ButtonModule } from 'primeng/button';
import { ButtonGroupModule } from 'primeng/buttongroup';
import { FloatLabelModule } from 'primeng/floatlabel';
import { FormsModule } from '@angular/forms';
import { IParty } from '@harlowe/core';
import { CurrencyPipe, NgFor, NgIf } from '@angular/common';
import { ILocation } from '@harlowe/core';
import { PartyService } from '@harlowe/core';
import { InputTextModule } from 'primeng/inputtext';
import { FacilityLocation } from '@harlowe/core';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { InputNumberModule } from 'primeng/inputnumber';
import { ChipModule } from 'primeng/chip'
import { CalendarModule } from 'primeng/calendar';
import { Diagnosis } from '@harlowe/core';
import { IMedicalBill } from '../../../models/medical-bill';
@Component({
  selector: 'app-medical-bill-editor',
  standalone: true,
  imports: [FieldsetModule,DropdownModule,ButtonModule,ButtonGroupModule,PartySearchComponent,
          FloatLabelModule,FormsModule, NgIf, InputTextModule, FacilityLocationSearchComponent,
          CardModule, TableModule, ProcedureSelectorComponent, DiagnosisSelectorComponent, CurrencyPipe, InputNumberModule,
          ModifierSelectorComponent,ChipModule, NgFor, CalendarModule
  ],
  templateUrl: './medical-bill-editor.component.html',
  styleUrl: './medical-bill-editor.component.scss'
})
export class MedicalBillEditorComponent 
{
  private _medicalBill : IMedicalBill = {} as IMedicalBill;
  diagnosesCodes: string[] = [];
  @Input() set medicalBill(val: IMedicalBill | undefined)
  {
    if(!val)
      this._medicalBill = {} as IMedicalBill
    else
      this._medicalBill = val;
    

    if(!this._medicalBill.insuredAddress)
      this._medicalBill.insuredAddress = {} as ILocation;
  }
  get medicalBill() : IMedicalBill
  {
    return this._medicalBill;
  }
  @Output() saved : EventEmitter<IMedicalBill> = new EventEmitter<IMedicalBill>();
  @Output() cancelled : EventEmitter<void> = new EventEmitter<void>();


  constructor(private _partyService : PartyService)
  {
    this._medicalBill.insuredAddress = {} as ILocation;
  }

  genders: string[] = ["Male","Female"];

  saveButtonPressed(event: MouseEvent)
  {
    this.saved.emit(this.medicalBill);
  }

  cancelButtonPressed(event: MouseEvent)
  {
    this.medicalBill = {} as IMedicalBill;
    this.cancelled.emit();
  }

  allowSave() : boolean
  {
    return this.medicalBill.patient != null && this.medicalBill.insuredName != null && 
          this.medicalBill.insuredAddress != null && this.medicalBill.insuredPhone != null &&
          this.medicalBill.patientAddress != null && this.medicalBill.phoneNumber != null &&
          this.medicalBill.servicingProvider != null &&
          this.medicalBill.patientAccountNumber != null && 
          this.medicalBill.billingProvider != null && this.medicalBill.lines != null && this.medicalBill.lines.length >= 1
          && this.medicalBill.lines.every(l => l.dateOfService != null);
  }

  clearPatient(event:MouseEvent)
  {
    if(this.medicalBill)
      this.medicalBill.patient = undefined;
  }

  async patientSelected(patient: IParty)
  {
    //Get the addresses and whatnot for the person

    this.medicalBill.patient = await this._partyService.getParty(patient.id);
  }

  servicingProviderChange(provider:FacilityLocation)
  {
    this.medicalBill.servicingProvider = provider;
  }

  clearServicingProvider(event: MouseEvent)
  {
    this.medicalBill.servicingProvider = undefined;
  }

  billingProviderChange(provider:FacilityLocation)
  {
    this.medicalBill.billingProvider = provider;
  }

  clearBillingProvider(event:MouseEvent)
  {
    this.medicalBill.billingProvider = undefined;
  }

  addLine(event:MouseEvent)
  {
    if(!this.medicalBill.lines)
    {
      this.medicalBill.lines = [];
    }

    this.medicalBill.lines = [...this.medicalBill.lines, {} as IMedicalBillLine]
  }

  removeLine(line: MedicalBillLine)
  {
    this.medicalBill.lines = [...this.medicalBill.lines.filter(l => l != line)]
  }

  diagnosesSet(diagnoses: Diagnosis[])
  {
    return diagnoses.map(d => d.code).join(', ');
  }

}
